import s from './LineBookingCard.module.scss';
import { LINE_URL } from '../config/socialLinks';
import { trackCtaClick } from '../utils/analytics';

const LineIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M20.4 11.9c0-4.5-4.2-8.1-9.4-8.1S1.6 7.4 1.6 11.9c0 4 3.3 7.3 7.7 8l-.3 2.3c0 .2.1.4.3.4.1 0 .2 0 .3-.1l2.7-1.9h.7c5.2 0 9.4-3.6 9.4-8.1z" />
  </svg>
);

const LineBookingCard = () => {
  return (
    <section className={s.root}>
      <h2>LINEで予約する</h2>

      <p>
        ご希望の日程や人数をLINEでお知らせください。
        <br />
        １時間以内に返信します。(ツアー中以外)
      </p>

      <a
        href={LINE_URL}
        target="_blank"
        rel="noreferrer"
        onClick={() => trackCtaClick({
          label: 'line_booking_card',
          placement: 'tour_detail_booking_card',
          destination: LINE_URL,
          destinationType: 'external_booking',
        })}
      >
        <LineIcon />
        LINEで予約する
      </a>

      <ul className={s.notes}>
        <li>空き状況の確認</li>
        <li>ご質問・ご相談もお気軽に</li>
      </ul>
    </section>
  );
};

export default LineBookingCard;
